// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  connectAuthEmulator,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { resolveEmulatorConfig } from "./utils/firebaseEmulatorConfig";

const emulator = resolveEmulatorConfig({
  REACT_APP_USE_FIREBASE_EMULATORS: process.env.REACT_APP_USE_FIREBASE_EMULATORS,
  REACT_APP_FIREBASE_EMULATOR_PROJECT: process.env.REACT_APP_FIREBASE_EMULATOR_PROJECT,
}, typeof window === "undefined" ? "" : window.location.hostname);

export const firebaseConfig = {
  apiKey: "AIzaSyDJ13PIa0YIpIotG0-RMXTcnTq5TS9CIfQ",
  authDomain: "accentsquotationapp.firebaseapp.com",
  projectId: "accentsquotationapp",
  storageBucket: "accentsquotationapp.firebasestorage.app",
  messagingSenderId: "366456468963",
  appId: "1:366456468963:web:b6581b637f64d4cfd35cd6",
};

export const app = initializeApp(emulator ? {
  apiKey: "fake-emulator-api-key", projectId: emulator.projectId,
  authDomain: `${emulator.projectId}.firebaseapp.com`,
  storageBucket: `${emulator.projectId}.appspot.com`, appId: "emulator-only",
} : firebaseConfig);

export const auth = getAuth(app);
if (emulator) connectAuthEmulator(auth, `http://${emulator.host}:${emulator.authPort}`, { disableWarnings: true });
setPersistence(auth, browserLocalPersistence);

export const db = getFirestore(app);
if (emulator) connectFirestoreEmulator(db, emulator.host, emulator.firestorePort);

export const storage = getStorage(app);
if (emulator) connectStorageEmulator(storage, emulator.host, emulator.storagePort);

export const functions = getFunctions(app, "asia-south1");
if (emulator) connectFunctionsEmulator(functions, emulator.host, emulator.functionsPort);
